import React from "react";
import { ReferenciaContenido } from "interfaces/ReferenciaContenido";

import "./indicatorBanner.scss"

const IndicatorBanner = ({tituloGeneral, descripcion, etiquetasArticulo, imagenPrincipal}: ReferenciaContenido) => {
    return (
        <section className="m-mentory-indicator-banner">
            <div className="m-mentory-indicator-banner__title-container">
                <h2 className="m-mentory-indicator-banner__title">{tituloGeneral}</h2>
            </div>
            <div className="m-mentory-indicator-banner__card-container">
                <img className="m-mentory-indicator-banner__img" alt={imagenPrincipal.title} src={imagenPrincipal.file.url}/>
                <div className="m-mentory-indicator-banner__indicator-container">
                    <span className="m-mentory-indicator-banner__indicator-number">{etiquetasArticulo[0].split(':')[0]}</span>
                    <p className="m-mentory-indicator-banner__indicator-text">{etiquetasArticulo[0].split(':')[1]}</p>
                </div>
            </div>
            <p className="m-mentory-indicator-banner__description">{descripcion.json.content[0].content[0].value}</p>
        </section>
    );
};

export default IndicatorBanner;